// assets
import { ControlFilled, GroupOutlined, TeamOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import useAuthContext from 'context/useAuthContext';

// type
import { SlidersOutlined, TagFilled } from '@ant-design/icons/lib/icons';
import { NavItemType } from 'layout/mantis/types/MenuType';
import useGlobalContext from 'context/useGlobalContext';

// icons
const icons = {
	controlFilled: ControlFilled,
	usergroupAddOutlined: UsergroupAddOutlined,
	groupOutlined: GroupOutlined,
	teamOutlined: TeamOutlined,
	tagFilled: TagFilled,
	slidersOutlined: SlidersOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

export default function CommunicationMenuItems() {
	const { permissions, roles } = useAuthContext();
	const { activeCompany } = useGlobalContext();
	let items: NavItemType = {};

	if (permissions) {
		if (
			permissions.some((el: string) => {
				return el === 'Manage_Group' || el === 'Manage_Meeting' || el === 'Base_Setting';
			})
		) {
			items = {
				id: 'group-communication',
				title: 'Communication',
				type: 'group',
				icon: icons.teamOutlined,
				children: []
			};

			// if (
			// 	permissions.some((el: string) => {
			// 		return el === 'Manage_Meeting';
			// 	})
			// ) {
			// 	items.children.push({
			// 		id: 'core-group-list-meeting',
			// 		title: 'Meetings',
			// 		type: 'item',
			// 		url: '/app/meeting/list/meetings',
			// 		icon: icons.groupOutlined,
			// 		breadcrumbs: true
			// 	});
			// }
			if (
				permissions.some((el: string) => {
					return el === 'Manage_Group';
				})
			) {
				items.children.push({
					id: 'core-group-list-group',
					title: 'Groups',
					type: 'item',
					url: '/app/group/list/groups',
					icon: icons.groupOutlined,
					breadcrumbs: true
				});
			}
			if (
				permissions.some((el: string) => {
					return el === 'My_Groups';
				})
			) {
				items.children.push({
					id: 'core-group-list-my-groups',
					title: 'My Groups',
					type: 'item',
					url: '/app/group/list/my/groups',
					icon: icons.groupOutlined,
					breadcrumbs: true
				});
			}

			if (activeCompany.value == null) {
				if (
					permissions.some((el: string) => {
						return el === 'Base_Setting';
					})
				) {
					let meeting_setting = {
						id: 'core-setting-meeting',
						title: 'Meeting',
						type: 'collapse',
						icon: icons.slidersOutlined,
						breadcrumbs: true,
						children: []
					};

					meeting_setting.children.push({
						id: 'core-setting-meeting-type',
						title: 'Meeting Type',
						type: 'item',
						url: '/app/settings/meeting/types',
						breadcrumbs: true
					});

					// if (
					// 	permissions.some((el: string) => {
					// 		return el === 'Manage_Meeting';
					// 	})
					// ) {
					// 	// meeting_setting.children.push({
					// 	// 	id: 'core-setting-mandatory_agenda',
					// 	// 	title: 'Mandatory Agenda',
					// 	// 	type: 'item',
					// 	// 	url: '/app/settings/mandatory/agendas',
					// 	// 	breadcrumbs: true
					// 	// });
					// }

					meeting_setting.children.push({
						id: 'core-setting-meeting-mode-of-communication',
						title: 'Modes of Communication',
						type: 'item',
						url: '/app/settings/mode/of/communication',
						breadcrumbs: true
					});

					meeting_setting.children.push({
						id: 'core-setting-meeting-frequency-of-meeting',
						title: 'Frequency of Meeting',
						type: 'item',
						url: '/app/settings/frequency/of/meeting',
						breadcrumbs: true
					});

					items.children.push(meeting_setting);
				}
			}
		}
	}

	return items;
}
